import { Serializable } from '../../../core/models/serializable';
import { ProductType } from '../../../product-purchases/shared/models/product-type';
import { AnnouncementModel } from '@admin/announcements/shared/models/announcement-model';
import { UserModel } from '@admin/core/user-model.model';
import { JobseekerModel } from '@admin/jobseekers/shared/models/jobseeker-model';

export enum AnnouncementMatchingJobseekerStatusEnum {
  None = 1,
  Accept = 2,
  Reject = 3,
  Ambiguous = 4,
}
